import * as React from 'react';
import MatchingArrow from 'components/Tables/grid/matchingArrow';
import { coupledDebounce } from 'components/Tables/helpers';

import elements from 'components/elements';

import {
  JETableRoot,
  JETableRowCell,
  JETableRow,
  JETableRowCellRemove,
  JE_TABLE_CLASSES,
} from 'components/Tables/grid/StyledComponents';
import cx from 'classnames';

const isLastOf = (data, index) => data.length - 1 === index;

class JETable extends React.Component {
  handleEnter = (hovered) => {
    const { setHovered } = this.props;
    setHovered(hovered, true);
  };

  handleLeave = (row) => {
    const { setHovered } = this.props;
    setHovered(row, false);
  };

  compoundHoverHandler = coupledDebounce(
    // MouseEnter handler
    this.handleEnter,
    // MouseLeave callback
    this.handleLeave,
    200, // delay
  );

  renderTextractMatchingAnchorRow = ({ row }) => {
    const { rtl, headerLineNumber, hovered } = this.props;
    const style = { position: 'sticky', ...(rtl ? { right: 0 } : { left: 0 }) };

    return (
      <td style={style}>
        <MatchingArrow headerLineNumber={headerLineNumber} hovered={hovered} row={row} />
      </td>
    );
  };

  render() {
    const {
      meta,
      prevItem,
      className,
      colgroup,
      getRowStyle,
      tableRef,
      prevElRef,
      getItem,
      getCellStyle,
      active,
      matchingArrowsPosition,
    } = this.props;

    const TextractMatchingColumn = this.renderTextractMatchingAnchorRow;

    return (
      <JETableRoot
        className={cx(JE_TABLE_CLASSES.TABLE, className)}
        cellSpacing="0"
        data-element={elements.je.container}
        ref={tableRef}
      >
        {colgroup()}
        <tbody>
          {meta[1].map((r, rIndex) => (
            <JETableRow
              key={r.toString()}
              className={cx(getRowStyle(r), {
                [JE_TABLE_CLASSES.ROW]: true,
                [JE_TABLE_CLASSES.ROW_FIRST]: rIndex === 0,
                [JE_TABLE_CLASSES.ROW_LAST]: isLastOf(meta[1], rIndex),
              })}
              onMouseEnter={this.compoundHoverHandler.enter(r)}
              onMouseLeave={this.compoundHoverHandler.leave(r)}
            >
              {matchingArrowsPosition === 'left' && <TextractMatchingColumn row={r} />}
              {prevItem ? <JETableRowCellRemove ref={prevElRef}>{prevItem(r)}</JETableRowCellRemove> : null}
              {meta[0].map((c) => (
                <JETableRowCell
                  key={c}
                  className={cx(
                    {
                      [JE_TABLE_CLASSES.CELL]: true,
                      'je-table-cell-active': active === c + r,
                      [JE_TABLE_CLASSES.CELL_FIRST]: rIndex === 0,
                      [JE_TABLE_CLASSES.CELL_LAST]: isLastOf(meta[1], rIndex),
                    },
                    getCellStyle(c, r),
                  )}
                >
                  {getItem(r, c)}
                </JETableRowCell>
              ))}
              {matchingArrowsPosition === 'right' && <TextractMatchingColumn row={r} />}
            </JETableRow>
          ))}
        </tbody>
      </JETableRoot>
    );
  }
}

JETable.defaultProps = {
  getItem: () => null,
  getRowStyle: () => null,
  getCellStyle: () => null,
  colgroup: () => null,
  setHovered: () => null,
  tableRef: () => null,
  matchingArrowsPosition: null,
};

export default JETable;
